export default "__VITE_ASSET__CAalg760__"